import React from 'react';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdEdit as EditIcon } from 'react-icons/md';

import { formatPhone } from 'helpers/Formatter';
import { CSSTransitionGroup } from 'react-transition-group';

const styles = {
  deleteIcon: { padding: '0px', height: '25px', position: 'absolute' },
  editIcon: { padding: '0px', height: '25px', position: 'absolute', left: '10px' },
  applicantCard: {
    paddingBottom: '10px',
    textTransform: 'capitalize',
    maxWidth: '500px',
    margin: 'auto',
  },
};

const SavedApplicants = ({ items, onEdit, onDelete, disabled }) => {
  return (
    <CSSTransitionGroup
      transitionName="add-edit-cotenants"
      transitionEnterTimeout={200}
      transitionLeaveTimeout={200}
    >
      {items.map((applicant, index) => {
        const unsaved = !applicant.id ? ' (unsaved)' : '';
        return (
          <div key={index} style={styles.applicantCard}>
            <div className="row">
              <div className="col-sm-5" style={{ textAlign: 'left' }}>
                <h4>First Name</h4>
                {applicant.first_name}
                {unsaved}
              </div>
              <div className="col-sm-4" style={{ textAlign: 'left' }}>
                <h4>Last Name</h4>
                {applicant.last_name}
              </div>

              <div className="col-sm-3" style={{ textAlign: 'center' }}>
                <EditButton disabled={disabled} onEdit={onEdit} index={index} />
                <DeleteButton disabled={disabled} onDelete={onDelete} index={index} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-5" style={{ textAlign: 'left' }}>
                <h4>Email</h4>
                {applicant.email}
              </div>
              <div className="col-sm-5" style={{ textAlign: 'left' }}>
                <h4>Phone Number</h4>
                {applicant.phone_number && formatPhone(applicant.phone_number)}
              </div>
            </div>
            {applicant.is_guarantor && (
              <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-sm-5" style={{ textAlign: 'left', textTransform: 'none' }}>
                  This applicant is a guarantor
                </div>
              </div>
            )}
          </div>
        );
      })}
    </CSSTransitionGroup>
  );
};

const DeleteButton = ({ disabled, onDelete, index }) => {
  if (disabled || !onDelete) return null;

  return (
    <IconButton style={styles.deleteIcon} onClick={() => onDelete(index)}>
      <DeleteIcon size={24} style={{ padding: '0px' }} />
    </IconButton>
  );
};

const EditButton = ({ disabled, onEdit, index }) => {
  if (disabled || !onEdit) return null;

  return (
    <IconButton style={styles.editIcon} onClick={() => onEdit(index)}>
      <EditIcon size={24} style={{ padding: '0px' }} />
    </IconButton>
  );
};

export default SavedApplicants;
